/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ c: NonNullable<unknown>, unit: NonNullable<unknown> }} Calorie_ConsoInputs */



/**
* | output |
* | --- |
* | "Calories: {c} {unit}" |
*
* @param {Calorie_ConsoInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const calorie_conso = /** @type {((inputs: Calorie_ConsoInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calorie_ConsoInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Calories: ${i?.c} ${i?.unit}`)
	return /** @type {LocalizedString} */ (`Calories : ${i?.c} ${i?.unit}`)
});